'use client';

import { usePathname } from 'next/navigation';
import { useEffect, useRef } from 'react';

import { internalTrackEvent, trackPageView } from '../core';
import { useIsTrackerReady } from '../hooks';
import { getWindowTrackerState, setWindowTrackerState, logger } from '../utils';

import type { FC} from 'react';

export const TrackerQueue: FC = () => {
  const ready = useIsTrackerReady();
  const executedForPathname = useRef<string | undefined>(undefined);
  const pathname = usePathname() ?? undefined;

  useEffect(() => {
    if (!ready || executedForPathname.current === pathname) {
      return;
    }

    executedForPathname.current = pathname;
    executeQueues({ pathname });
  }, [ready, pathname]);

  return null;
};

const executeQueues = (ctx: { pathname?: string }) => {
  const { pageViewQueue, eventQueue } = getWindowTrackerState();

  logger.log(
    `Executing tracking queues in context of "${ctx.pathname}": ${pageViewQueue.length} page views in queue. ${eventQueue.length} events in queue.`,
  );

  setWindowTrackerState({
    pageViewQueue: [],
    eventQueue: [],
  });

  pageViewQueue.forEach(data => trackPageView(data));
  eventQueue.forEach(({ data, resolve, reject }) =>
    internalTrackEvent(data, resolve, reject),
  );
};
